/* eslint-disable indent */
'use client';

import { useState, useEffect } from 'react';
import { Search } from 'lucide-react';

export default function PropertyFilters({
  initialFilters,
  onFilterChange,
  onClose,
}) {
  // const [filters, setFilters] = useState(initialFilters);
  const [filters, setFilters] = useState({
    ...initialFilters,
    bedrooms: initialFilters.bedrooms ? initialFilters.bedrooms.split(',') : [],
    bathrooms: initialFilters.bathrooms
      ? initialFilters.bathrooms.split(',')
      : [],
  });

  const [debouncedFilters, setDebouncedFilters] = useState(initialFilters);

  const propertyTypes = [
    { value: '', label: 'All Types' },
    { value: 'AP', label: 'Apartment' },
    { value: 'VH', label: 'Villa' },
    { value: 'TH', label: 'Townhouse' },
    { value: 'PH', label: 'Penthouse' },
    { value: 'LP', label: 'Land' },
    { value: 'OF', label: 'Office' },
    { value: 'RE', label: 'Retail' },
    { value: 'SH', label: 'Shop' },
    { value: 'WH', label: 'Warehouse' },
  ];

  const bedroomOptions = [
    { value: '', label: 'Any' },
    { value: '0', label: 'Studio' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6+', label: '6+' },
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest' },
    { value: 'price-asc', label: 'Price (Low to High)' },
    { value: 'price-desc', label: 'Price (High to Low)' },
  ];

  const bathroomOptions = [
    { value: '', label: 'Any' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5+', label: '5+' },
  ];

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);
    return () => clearTimeout(timer);
  }, [filters]);

  // useEffect(() => {
  //   onFilterChange(debouncedFilters);
  // }, [debouncedFilters, onFilterChange]);

  // Keep filters only locally:
  // useEffect(() => {
  //   setFilters(initialFilters);
  // }, [initialFilters]);

  useEffect(() => {
    setFilters({
      ...initialFilters,
      bedrooms: initialFilters.bedrooms
        ? initialFilters.bedrooms.split(',')
        : [],
      bathrooms: initialFilters.bathrooms
        ? initialFilters.bathrooms.split(',')
        : [],
    });
  }, [initialFilters]);

  const resetFilters = () => {
    setFilters({
      propertyType: '',
      minPrice: '0',
      maxPrice: '100000000',
      bedrooms: [],
      bathrooms: [],
      location: '',
      refNo: '',
      sortBy: 'newest',
    });
  };

  const toggleMultiSelect = (name, value) => {
    setFilters((prev) => {
      const currentValues = prev[name] || [];
      const exists = currentValues.includes(value);

      return {
        ...prev,
        [name]: exists
          ? currentValues.filter((v) => v !== value)
          : [...currentValues, value],
      };
    });
  };

  // useEffect(() => {
  //   if (onClose) {
  //     document.body.style.overflow = 'hidden';
  //   }

  //   return () => {
  //     document.body.style.overflow = '';
  //   };
  // }, [onClose]);

  return (
    <div className='space-y-6'>
      {/* Sort By */}
      <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Sort By
        </label>
        <select
          name='sortBy'
          value={filters.sortBy}
          onChange={handleFilterChange}
          className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
        >
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Property Type */}
      <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Property Type
        </label>
        <select
          name='propertyType'
          value={filters.propertyType}
          onChange={handleFilterChange}
          className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
        >
          {propertyTypes.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      {/* Price Range */}
      <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Price Range (AED)
        </label>
        <div className='flex items-center gap-2'>
          <input
            type='number'
            name='minPrice'
            value={filters.minPrice}
            onChange={handleFilterChange}
            placeholder='Min'
            className='w-1/2 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
          />
          <span className='text-gray-500'>-</span>
          <input
            type='number'
            name='maxPrice'
            value={filters.maxPrice}
            onChange={handleFilterChange}
            placeholder='Max'
            className='w-1/2 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
          />
        </div>
      </div>

      {/* Bedrooms */}
      {/* <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Bedrooms
        </label>
        <select
          name='bedrooms'
          value={filters.bedrooms}
          onChange={handleFilterChange}
          className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
        >
          {bedroomOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div> */}
      <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Bedrooms
        </label>

        <div className='flex flex-wrap gap-2'>
          {bedroomOptions
            .filter((o) => o.value)
            .map((option) => (
              <button
                key={option.value}
                type='button'
                onClick={() => toggleMultiSelect('bedrooms', option.value)}
                className={`px-3 py-1.5 rounded-full border text-sm transition
            ${
              filters.bedrooms?.includes(option.value)
                ? 'bg-primarycolor text-white border-primarycolor'
                : 'bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200'
            }
          `}
              >
                {option.label}
              </button>
            ))}
        </div>
      </div>

      {/* Bathrooms */}
      {/* <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Bathrooms
        </label>
        <select
          name='bathrooms'
          value={filters.bathrooms}
          onChange={handleFilterChange}
          className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
        >
          {bathroomOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div> */}
      <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Bathrooms
        </label>

        <div className='flex flex-wrap gap-2'>
          {bathroomOptions
            .filter((o) => o.value)
            .map((option) => (
              <button
                key={option.value}
                type='button'
                onClick={() => toggleMultiSelect('bathrooms', option.value)}
                className={`px-3 py-1.5 rounded-full border text-sm transition
            ${
              filters.bathrooms?.includes(option.value)
                ? 'bg-primarycolor text-white border-primarycolor'
                : 'bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200'
            }
          `}
              >
                {option.label}
              </button>
            ))}
        </div>
      </div>

      {/* Location */}
      <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Location
        </label>
        <div className='relative'>
          <input
            type='text'
            name='location'
            value={filters.location}
            onChange={handleFilterChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.preventDefault(); // Prevent form submit
            }}
            placeholder='Enter location'
            className='w-full px-4 py-2 pl-10 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
          />
          <Search
            className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400'
            size={18}
          />
        </div>
      </div>

      {/* Reference Number */}
      <div>
        <label className='block text-gray-700 dark:text-gray-300 font-medium mb-2'>
          Reference Number
        </label>
        <input
          type='text'
          name='refNo'
          value={filters.refNo}
          onChange={handleFilterChange}
          placeholder='Enter reference number'
          className='w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-primarycolor dark:focus:ring-secondarycolor focus:border-primarycolor dark:focus:border-secondarycolor bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
        />
      </div>

      {/* Action Buttons */}
      {/* <div className='flex gap-2'>
        <button
          onClick={resetFilters}
          className='flex-1 px-4 py-2 bg-primarycolor hover:bg-secondarycolor text-white hover:text-black rounded-lg dark:hover:bg-secondarycolor transition-colors'
        >
          Reset
        </button>
        {onClose && (
          <button
            onClick={onClose}
            className='flex-1 px-4 py-2 bg-primarycolor dark:bg-secondarycolor text-white dark:text-black rounded-lg hover:bg-primarycolor/90 dark:hover:bg-secondarycolor/90 transition-colors'
          >
            Apply
          </button>
        )}
      </div> */}

      <div className='flex gap-2'>
        <button
          onClick={resetFilters}
          className='flex-1 px-4 py-2 bg-primarycolor hover:bg-secondarycolor text-white hover:text-black rounded-lg dark:hover:bg-secondarycolor transition-colors'
        >
          Reset
        </button>
        <button
          // onClick={() => {
          //   if (onClose) onClose();
          //   onFilterChange(filters);
          // }}
          onClick={() => {
            const payload = {
              ...filters,
              bedrooms: filters.bedrooms.join(','),
              bathrooms: filters.bathrooms.join(','),
            };

            if (onClose) onClose();
            onFilterChange(payload);
          }}
          className='flex-1 px-4 py-2 bg-primarycolor hover:bg-secondarycolor text-white hover:text-black rounded-lg dark:hover:bg-secondarycolor transition-colors'
        >
          Apply
        </button>
      </div>
    </div>
  );
}
